// src/app/utils/error.ts
import axios from 'axios';
import {ErrorModel} from "@/app/api/request";

export function isErrorModel(obj: any): obj is ErrorModel {
  return obj && typeof obj.error === 'string' && typeof obj.status === 'number';
}

export function parseError(err: unknown): ErrorModel {
  if (isErrorModel(err)) {
    if (err.error === 'This user is blocked, login impossible.') {
      return {
        ...err,
        error: 'The user is blocked by admin. Please contact support',
      };
    }
    return err;
  }

  if (axios.isAxiosError(err)) {
    return {
      error: err.message,
      status: err.response?.status ?? 0,
    };
  }

  if (err instanceof Error) {
    return {
      error: err.message,
      status: 0,
    };
  }

  return {
    error: 'Unknown error',
    status: 0,
  };
}